import * as Yup from 'yup';

export const VALIDATION_SCHEMA = t =>
  Yup.object({
    country: Yup.mixed().required(t('bank_details_form.country_is_required')),
    beneficiary_name: Yup.string().required(t('bank_details_form.beneficiary_name_is_required')),
    in_sepa_zone: Yup.boolean(),
    is_valid_sepa: Yup.bool().oneOf([true], t('bank_details_form.valid_iban_is_required')),
    account_number: Yup.string().required(t('bank_details_form.iban_is_required')),
    account_currency: Yup.object().required(t('bank_details_form.currency_is_required')),
    files: Yup.array()
      .min(1, t('bank_details_form.bank_statement_required_field'))
      .required(t('bank_details_form.bank_statement_required_field')),
    swift: Yup.string().when(['in_sepa_zone'], {
      is: isSepa => isSepa !== true,
      then: () => Yup.string().required(t('bank_details_form.swift_bic_code_is_required')),
    }),
    beneficiary_address: Yup.string().when(['in_sepa_zone'], {
      is: isSepa => isSepa !== true,
      then: () => Yup.string().required(t('bank_details_form.address_is_required')),
    }),
    beneficiary_bank: Yup.string().when(['in_sepa_zone'], {
      is: isSepa => isSepa !== true,
      then: () => Yup.string().required(t('bank_details_form.bank_name_is_required')),
    }),
    beneficiary_bank_address: Yup.string().when(['in_sepa_zone'], {
      is: isSepa => isSepa !== true,
      then: () => Yup.string().required(t('bank_details_form.bank_address_is_required')),
    }),
  });
